var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.data.direct_delivery)?_c('font-awesome-icon',{staticClass:"mr-2",attrs:{"icon":"truck"}}):_vm._e(),_c('strong',[_vm._v(_vm._s(_vm.getProducerName()))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }